export default __webpack_public_path__ + "static/media/logo-nexus-white.f5125078.png";